module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmint",
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "pre1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROGRESSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("The Will of God is surely among the most ambitious subjects man is confronted with. Can we ever realistically hope to understand it?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Some approach God’s Will with awe and timidity, others with boldness and over-confidence. Some live their lives independent of any higher scheme, or "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Will")]), _vm._v(", in the universe. Others, of many faiths, try to order their lives by an understanding of “God’s Will.” Yet their practical conception of what God’s Will actually is leads some to blow up airplanes and others in thousands of equally self-motivated directions in the name of following what they think God wants them to do.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Obviously there is much confusion.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("There is only one who lived and taught the real thing—who actually said that he "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("knew")]), _vm._v(" God’s Will for all humankind—a man who lived in it, and taught his followers to do likewise. Unless one is a daily, dedicated disciple of Jesus Christ, obeying his teachings and seeking to follow his example, there is no “God’s Will” to be found. Jesus is the only door into the discovery of God’s practical, daily, live-able Will. When it comes to translating high truth about God into our daily workplaces and choices and decisions and attitudes—what we are actually supposed to "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("do")]), _vm._v(" and "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("not do")]), _vm._v(", Jesus himself is the only guide into the practical realities of what comprise God’s Will.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("A fundamentalist "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Jesus-is-the-only-way-to-salvation")]), _vm._v(" theology should not be read into that statement. This is not an inquiry about salvation, or trying to understand who is saved and who isn’t and why. We are only establishing the clear fact that Jesus is the only individual in history whose bold claim—"), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("I know God’s will and you can know it too if you follow my teaching")]), _vm._v("—is reliable and worthy to be heeded. Many crackpots through the years have claimed to know God’s will. But Jesus is obviously on a different plane altogether. For "), _c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("anyone in earnest about truly discerning the will of God, Jesus is really the only game in town.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Following Jesus at its most basic means to live within the Will of the Father, just as he did. “If any man would be my disciple,” Jesus said, “he must . . . follow me.”")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Jesus explained further, in John’s gospel, by speaking frequently of the subservience of his own will into God’s higher Will:")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Whatever the Father does the Son also does, for the Father . . . shows him all he does. (5:19-20)")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("I have come . . . not to do my will but to do the will of him who sent me. (6:38)")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("I live because of the Father. (6:57)")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("My teaching is not my own. (7:16)")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("I do nothing on my own but speak just what the Father has taught me. (8:28)")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("I always do what pleases him. (8:29)")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("I honor my Father. (8:49)")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("It is clear that his life had only one purpose. Jesus lived "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("within")]), _vm._v(" the will of his Father.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("He calls us to such a moment-by-moment existence as well—not sporadically, but continuously . . . not perfectly, perhaps, but significantly . . . not without mistakes, but undergirded by constancy of motive and attempt. This is discipleship. This is the Christian faith reduced to its most fundamental terms: Living in God’s Will as Jesus did, by following his example and doing our daily best to order out behavior, attitudes, and life priorities according to his teaching.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PROGRESSIVE THINKING AS FOUNDATIONAL TO UNDERSTAND GOD")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S WILL")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("In all spiritual inquiries, thinking progressively is imperative to wisdom and understanding—beginning at beginnings and building foundations before launching into higher and more expansive inquiries.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Such a pattern can be called implicational thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("We must think implicationally to discover truth as it comes to us "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("progressively")]), _vm._v(" revealed in Scripture. Therefore, we must also keep vigilantly aware of the logical conclusions of our presuppositions. We must drive any series of ideas or beliefs or doctrines or assumptions "), _c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("to their logical extension and endpoint to see where they land us when followed to the end. If we hope to exercise an impact in the world, we "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("must")]), _vm._v(" think this way about matters of faith. Pat answers and formulas will no longer do.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Mathematics, and indeed all rationality as well as spiritual truth, is based on orderly progressions from presupposition to conclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If A . . . then B.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If B . . . then C.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If C . . . then D and E must follow in logical sequence. Eventually we arrive at some complex truth that is built on a framework of logical, foundational, implicational thinking. This is how discoveries in science are made. It is also how discoveries are made in high realms of spiritual truth.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("The Scriptures cannot possibly open their greatest mysteries unless we use the brains and logic—undergirded in prayer, led by the Holy Spirit, the Spirit of truth—God gave us. Yet because of a refusal to use rationality and common sense to understand God, many questionable Christian doctrines have been built on a series of illogical leaps between A and H. The dots of spiritual logic and scriptural progressions are not connected. Much is thus believed by Christians who have been taught that truth isn’t supposed to make sense. As a result, Christianity’s impact in intellectual circles is presently at its lowest ebb in two thousand years.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If X is true . . . then F can’t be true.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If J is true . . . then P.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If M is true . . . we can’t know anything for sure.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("So I believe in H.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Disconnects all over the place. No progressions of scriptural integrity from A to B to C and logically through to the end. No recognition of what makes sense and what doesn’t. Doctrines and belief systems exist in a progressional, implicational void, unrelated from each other and disconnected from foundations of scriptural truth. And Christians are told this is the way it is "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("supposed")]), _vm._v(" to be. Just accept what you are taught and don’t question. The way of the cross is foolishness . . . and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Dorothy Sayers pithy response to such sloppy Christian thinking more than half a century ago was unequivocal: —“Balderdash!”")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("The importance of sequential A-B-C implicational scriptural thinking is imperative as we begin this discussion. Our attempt to probe the Will of God will be based on "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("progressions")]), _vm._v(". To accurately understand the Will of God at any level requires an awareness of the Will of God at certain "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("previous")]), _vm._v(" levels. The dots must connect. A void anywhere along the line will confuse one’s understanding of God’s Will at the next level. Error will be introduced into the process and render whatever conclusions follow incomplete or inaccurate.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If I hope to pray effectively today about God’s Will for me at this particular moment, I have to be clear about God’s greater overall Will in my life. The "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Higher Will")]), _vm._v(" always leads to the more "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("specific will")]), _vm._v(". We will observe this progression continually. The two must point in the same direction. In other words, I have to pray "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("today")]), _vm._v(" in ways consistent with how God is working in my life in a "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("general")]), _vm._v(" way. Without such harmony of purpose, I may pray in one direction while God is actually trying to work in another direction. If I am out of tune with God’s larger purpose, how can I possibly perceive his Will with accuracy or pray for guidance effectively?")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Progressive thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "toc_entry2"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE SEVENFOLD PROGRESSION OF GOD")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S REVEALED WILL")])]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("We can identify seven ways (there are others, but these will form the basis for our study) in which God reveals his Will to mankind. His method of revelation is distinct for each.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("God reveals his Will through:")]), _vm._v(" "), _c('p', {
    staticClass: "fmint1"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("His own being")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fmint1"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("His revealed Will for the universe")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fmint1"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("General principles and universal commands given to mankind")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fmint1"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Specific commands given to mankind")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fmint1"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Guidance from the Scriptures")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fmint1"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Guidance from the Holy Spirit")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fmint1"
  }, [_c('em', {
    staticClass: "calibre3"
  }, [_vm._v("Guidance from wise counselors")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("These are not all there is to God’s Will. But they cover the most recognizable and specific means by which he is continually revealing himself to mankind. Other aspects of his Will may exist but may be a sealed book to us.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("His will for the animal kingdom, for example, would include that mysterious thing we call “instinct.” Why do animals do what they do? God has implanted within them the capacity to know what they are supposed to do. I assume this represents his “Will” for them. But it is a sealed book to us. We are men, created in the image of God, not animals. We can only know about the instinct he placed within "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("us")]), _vm._v(", which is our conscience.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Likewise, God may have a “will” for other worlds of his creation if earth is not his only such creation. Whether this is a possibility or not, no iota of information has been given us except for Jesus’ cryptic comment in John 10:16. There may be many regions and realms of activity within the scope of God’s purpose that we know nothing about. God may do some new thing ten billion years from now in the distance of eternity that we could not possibly understand even if he told us. All we can know is that he has placed these seven realms before "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("us")]), _vm._v(" now in our present human condition. Therefore, these are the aspects of God’s Will we must seek to understand.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Similarly, how God leads you within the quietness of "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("your")]), _vm._v(" heart in revealing to you his Will, is a closed book to "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("me")]), _vm._v(", just as his leading to me is a closed book to you. The very nature of such guidance is invisible and personal. Great mischief has been perpetrated in the church by those who think that they should intrude into that process, and into the quiet inner sanctum of other prayer closets than their own, and tell everybody "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("else")]), _vm._v(" what God wants them to do. But generally such leading is private and personal.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Even in the above progression, there are mysteries upon mysteries upon mysteries. To what extent can we really probe the heart of God’s nature and character? How deeply can we see into the creation, the millennium, the lake of fire, heaven, hell, the Book of Life, and other such aspects of God’s plan that fall into the realm of his “eternal” purposes? There is far more of God’s Will we "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("cannot")]), _vm._v(" know than what we "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("can")]), _vm._v(" know.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("By identifying this progressive revelation, I do not suggest that we can grasp his Will in any of the seven with precise and unmistakable clarity. God truly is "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("unknowable")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("Yet in one of the many dichotomies that make up the Christian faith, God wants us to "), _c('em', {
    staticClass: "calibre3"
  }, [_vm._v("know")]), _vm._v(" him. He wants us to seek the very thing that, by its nature, will always to some degree elude us.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("But we cannot know him piecemeal, disconnected from the progressivity by which his Will is revealed. If A . . . then B . . . then C . . . then D . . . then E, and so on. God’s Will always come through an ascending and descending series of revelations, each dependent upon what has been established before.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If God is . . . then God must . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If God will . . . then mankind must . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If mankind is to live according to . . . then God has a claim on me to . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("If I am to live . . . then on this day God wants me to . . . ")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("The “specific will” always flows out of the higher and more “general Will.” We cannot hope to live in a lesser, lower, more specific revelation of God’s Will that is at odds and disconnected from the higher and more eternal revelation of that Will.")]), _vm._v(" "), _c('p', {
    staticClass: "pre2"
  }, [_vm._v("With this principle of progressivity in place, let us embark together on our time of study, reflection, and prayer that will help us know God’s Will and live in it every day.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-541d3dd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0004.vue
// module id = 72
// module chunks = 0